import { useEffect, useReducer, useState } from "react";

import { useSelector } from "react-redux";
import "./MappingStatusActions.css";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover } from "antd";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { deleteImportbyId } from "../../apis/dataMapping/dataMapping";

const MappingStatusActions = (params: any) => {
  const { t } = useTranslation();
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const ActiveClient = useSelector(
    (state: any) => state.clientDetails.activeClient
  );

  const [showDownloadErrorLog,setShowDownloadErrorLog]=useState(false);

  //popover vars --------
  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
  };


  useEffect(()=>{
    const errData = JSON.parse(params.rowData.ErrorLogObject);
    if(errData.length>0){
      setShowDownloadErrorLog(true);
    }

  },[params.rowData])

  const addErrorData = (data:any) => {
    let JData:any=[];
    
    data.forEach((element:any) => {
      let obj ={
        ...element.record_data,
        "Error Details":element.error_details.toString()
      };
      JData.push(obj);
    });
    return JData;

     
  };


  const handleOpenChange = (newOpen:any) => {
    setOpen(newOpen);
  };


  const getRandomFileName = () => {
    const timestamp = new Date().getTime();
    const randomString = Math.random().toString(36).substring(7);
    return `${params.rowData.File_Nm}_${timestamp}_${randomString}`;
  };

  const convertToExcel = () => {
    const data = JSON.parse(params.rowData.ErrorLogObject);
    const dataWithRandom:any = addErrorData(data);
    console.log("convertToExcel----data---->",dataWithRandom);
    const ws = XLSX.utils.json_to_sheet(dataWithRandom);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' }); 
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const filename = getRandomFileName();
    saveAs(blob, `${filename}.xlsx`);
  };


  const deleteImport = () => {
    console.log("Deleted Import 1");
    deleteImportbyId(params.rowData.Id,(resp:any)=>{
      if(resp){
        
        console.log("Deleted Import");
        params.onDelete();
        hide();
      }
    })
  };


  const content = (
    <div className="mappingStatus-actionBtns">
      {showDownloadErrorLog && <div onClick={convertToExcel} className="pd-md">Download Failed Records</div>}
       <div onClick={deleteImport} className="pd-md">Delete Entry</div>
    </div>
  );


  return (
    <>
      
      <Popover
        content={content}
        placement="bottomLeft"
        trigger="click"
        open={open}
        onOpenChange={handleOpenChange}
      >
        <div className="header-3dots-icon primary-color" >
        <FontAwesomeIcon
          className="create-icon"
          icon={["fas", "ellipsis-vertical"]}
          size="xl"
        />
      </div>
      </Popover>
    </>
  );
};

export default MappingStatusActions;
